import * as Yup from 'yup';

import {
  currentPasswordSchema,
  newPasswordConfirmationSchema,
  newPasswordSchema,
} from '../../PasswordChange/schemas/new-password.schema';

export const MyDataSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("L'adresse e-mail n'est pas valide")
    .required("L'adresse e-mail est requise"),
  // Empty, the current password is kept.
  newPassword: newPasswordSchema,
  newPasswordConfirmation: newPasswordConfirmationSchema,
  currentPassword: currentPasswordSchema,
});
